import React, { useContext, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import InputDefault from '../../../components/InputDefault';
import Select from '../../../components/Select';
import { DefaultLargeButton, SecondaryLargeButton } from '../../../components/Buttons/styles';
import { meansOfDisbursementSteps } from '../../../helpers/enum';
import FormTemplate from '../../../components/FormTemplate';
import { Form, FormFooter, FormRow } from '../../../components/FormTemplate/styles';
import { MeansOfDisbursementContext } from "../../../store";
import { useHistory, useLocation } from 'react-router-dom';
import { clientTypes } from '../../../helpers/enum';
import { default as MeansOfDisbursementTypes } from '../../../store/MeansOfDisbursement/types';
import { meansOfDisbursementRegister } from '../../../services/meansOfDisbursement';

const SuggestedCustomerSegmentAndTypePage = ({ setActiveStep }) => {
  const history = useHistory();
  const location = useLocation();
  const { meansOfDisbursement, setMeansOfDisbursement } = useContext(MeansOfDisbursementContext);
  const { control, handleSubmit, errors, register } = useForm({ defaultValues: meansOfDisbursement.suggestedCustomerSegmentAndType });
  const [showClientTypes, setShowClientTypes] = useState(false);

  async function setCompleteStep(data) {
    try {
      const req = {
        idCredito: location.idCredit,
        numeroCuenta: meansOfDisbursement.disbursementModality.numeroCuenta,
        idTipoCuenta: meansOfDisbursement.disbursementModality.accountType.id,
        idDepartamento: meansOfDisbursement.disbursementModality.state.id,
        idCiudad: meansOfDisbursement.disbursementModality.city.id,
        idModalidadDesembolso: meansOfDisbursement.disbursementModality.modalidad.id,
        idTipoCliente: meansOfDisbursement.suggestedCustomerSegmentAndType.clientType.id,
        idEntidadFinanciera: meansOfDisbursement.disbursementModality.financialEntitie.id
      }
      await meansOfDisbursementRegister(req);
      history.push({
        pathname: '/admin/data-solicitation',
        idCredit: location.idCredit,
        client: {
          id: meansOfDisbursement.solicitation.cliente.id,
          identification: meansOfDisbursement.solicitation.cliente.identificacion,
          identificationType: meansOfDisbursement.solicitation.cliente.tipoIdentificacion
        }
      });
    } catch (error) {
      console.log(error.response)
    }
  }

  function setAccountType(clientType) {
    setMeansOfDisbursement({
      type: MeansOfDisbursementTypes.SET_CLIENT_TYPE,
      clientType: clientType,
    });
  }

  return (
    <FormTemplate 
      idForm="suggested-customer-segment-and-type-step-page"
      activeStep="2/2"
      stepLabel="Segmento y tipo de cliente sugerido">
      <Form  onSubmit={handleSubmit(setCompleteStep)}>
        <FormRow col="2">
          <Controller
            as={InputDefault}
            control={control}
            label="Segmento"
            name="segmento"
            id="segmento"
            defaultValue={meansOfDisbursement.disbursementModality.meansOfDisbursement.segmento}
            error=""
            readOnly />

          <Select
            error={errors.tipoCliente}
            setShow={setShowClientTypes}
            show={showClientTypes}
            defaultValue={meansOfDisbursement.suggestedCustomerSegmentAndType.clientType.nombre}
            setSelected={setAccountType}
            list={clientTypes}
            placeholder="Seleccionar..."
            label="Tipo de cliente"
            name="tipoCliente"
            id="tipoCliente"
            register={register({ required: "Este dato es obligatorio" })} />
        </FormRow>
        <FormFooter justify="space-between">
          <DefaultLargeButton type="button" onClick={() => setActiveStep(meansOfDisbursementSteps.DISBURSEMENT_MODALITY)}>Volver</DefaultLargeButton>
          <SecondaryLargeButton type="submit">Siguiente</SecondaryLargeButton>
        </FormFooter>
      </Form>
    </FormTemplate>
  )
}

export default SuggestedCustomerSegmentAndTypePage;
